import { render, staticRenderFns } from "./VueDataTableFormText.vue?vue&type=template&id=5497ad0b&scoped=true"
import script from "./VueDataTableFormText.vue?vue&type=script&lang=js"
export * from "./VueDataTableFormText.vue?vue&type=script&lang=js"
import style0 from "./VueDataTableFormText.vue?vue&type=style&index=0&id=5497ad0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497ad0b",
  null
  
)

export default component.exports